export default window.__litium.constants
